import Section from "components/common/Section";
import StaticPageHeader from "components/common/StaticPageHeader";
import usePageMeta from "hooks/usePageMeta";

const Contact = () => {
  usePageMeta(
    "Contact Ubay | Islamic Quiz Platform Pakistan",
    "Get in touch with the Ubay team. We welcome questions about our Islamic quiz platform, content suggestions, and account support. Email: ubayplatform@gmail.com",
    "/contact"
  );

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <img src="/assets/imgs/bg.jpg" alt="" className="fixed inset-0 h-full w-full object-cover -z-10" />

      <StaticPageHeader currentPage="Contact" />
      <Section asMain>
        <div className="py-8 sm:py-12">
          <div className="max-w-3xl mx-auto space-y-8">

            {/* Hero */}
            <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-6 sm:p-8 shadow-xl">
              <p className="text-sm font-semibold text-emerald-600 mb-2">We are here to help</p>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">Contact</h1>
              <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
                Reach out if you have questions about Ubay, content suggestions, or need account support.
              </p>
            </div>

            {/* Contact Card */}
            <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-6 sm:p-8 shadow-lg space-y-5">
              <div>
                <p className="text-xs sm:text-sm uppercase tracking-wide text-slate-500 mb-1">Name</p>
                <p className="text-lg sm:text-xl font-semibold text-slate-900">Ubay</p>
              </div>
              <div>
                <p className="text-xs sm:text-sm uppercase tracking-wide text-slate-500 mb-1">Email</p>
                <a className="text-lg sm:text-xl font-semibold text-emerald-700 underline decoration-emerald-200 hover:decoration-emerald-500 transition-colors" href="mailto:ubayplatform@gmail.com">
                  ubayplatform@gmail.com
                </a>
              </div>
              <div className="rounded-xl bg-emerald-50/90 border border-emerald-200/60 text-emerald-900 px-4 py-3 text-sm sm:text-base">
                Currently we are only operating in Pakistan.
              </div>
            </div>

          </div>
        </div>
      </Section>
    </div>
  );
};

export default Contact;
